import React, { FC } from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import { getText } from '../../../../utilities/CultureUtilities';
import { CultureTextModel } from '../../../../models/form/form';

export interface Props {
  id?: string;
  noEmptyValue?: boolean;
  enabled?: boolean;
  placeholder?: string;
  value: string | undefined;
  touched?: boolean;
  error?: string;
  options?: Array<{ text: CultureTextModel[] | string; value: string; disabled?: boolean }> | undefined;
  onChange: React.ChangeEventHandler<any>;
  onBlur?: React.FocusEventHandler<any>;
  size?: 'sm' | 'lg';
  rest?: Record<string, unknown>;
  style?: React.CSSProperties;
  readOnlyMode?: boolean;
  customOptions?: React.ReactNode;
  culture?: string;
}

const SelectInput: FC<Props> = ({
  id,
  noEmptyValue,
  value,
  touched,
  error,
  enabled = true,
  placeholder,
  onChange,
  options,
  onBlur,
  size,
  rest,
  style,
  readOnlyMode,
  customOptions,
  culture,
}: Props) => {
  return (
    <InputGroup>
      <FormControl
        isValid={touched && !error}
        isInvalid={touched && !!error}
        size={size}
        name={id}
        disabled={!enabled || readOnlyMode}
        as="select"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        style={style}
        data-testid="select-input"
        className="form-control"
        {...rest}
      >
        {!noEmptyValue && <option value={''}>{readOnlyMode ? '' : getText(placeholder, culture)}</option>}
        {customOptions && customOptions}
        {!customOptions &&
          options &&
          options.length > 0 &&
          options.map((option) => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {getText(option.text, culture)}
            </option>
          ))}
      </FormControl>
    </InputGroup>
  );
};

export default SelectInput;
